<script setup>
import { ref } from "vue"

defineProps({
  name: { type: String, default: "world" },
})

const count = ref(0)
</script>

<template>
  <div class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <p class="text-slate-700">Hello, {{ name }} — this is a Vue component.</p>
    <button
      class="mt-4 rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700"
      @click="count++"
    >
      Clicked {{ count }} times
    </button>
  </div>
</template>
